import { createSlice } from "@reduxjs/toolkit";

const initialClusterresidentialState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: {total : 0},
  links: null,
  lastError: null,
  clusterresidentialForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const clusterresidentialSlice = createSlice({
  name: "clusterresidential",
  initialState: initialClusterresidentialState,
  reducers: {
		catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
		clusterresidentialFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
		clusterresidentialAllFetched: (state, action) => {
      const { count, entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = count;
    },
    clusterresidentialCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.clusterresidential.push(action.payload.clusterresidential);
    },
    clusterresidentialDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.clusterresidential.filter(el => el.clusterresidential_id !== action.payload.id);
    },
    getClusterresidential: (state, action) => {
      state.actionsLoading = false;
      state.clusterresidentialForEdit = action.payload.clusterresidentialForEdit;
      state.error = null;
    },
    // updateProduct
    clusterresidentialUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.clusterresidential = state.entities.clusterresidential.map(entity => {
        if (entity.clusterresidential_id === action.payload.clusterresidential.clusterresidential_id) {
          return action.payload.clusterresidential;
        }
        return entity;
      });
    },
  },
});
